module.exports = __webpack_public_path__ + "static/media/IMG_0151.20c6d807.jpg";